export const environment = {
  production: true,
  connection: {
    name: 'LH Vöcklabruck Softline',
    host: 'https://softline-test.vb-gm.rlh.at',
    port: 443,
    basePath: '/api',
  },
  androidUpdateRepository: '',
};
